import React from 'react';
import s from './style.css';
const Loading = ({ colored, white }) => {
    return React.createElement("div", { className: `${s.loader} ${colored ? s.colored : white ? s.white : s.black}` });
};
export default Loading;
